import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const LightBulbIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 1a7 7 0 0 0-7 7 5.66 5.66 0 0 0 1.83 4.24c.56.52.95 1.2 1.1 1.96a1 1 0 0 0 1.96-.4 5.61 5.61 0 0 0-1.7-3.02A3.66 3.66 0 0 1 7 8a5 5 0 1 1 10 0v.02a3.65 3.65 0 0 1-1.2 2.77 5.58 5.58 0 0 0-1.7 3.03 1 1 0 1 0 1.97.36c.14-.72.47-1.3 1.12-1.96A5.65 5.65 0 0 0 19 8a7 7 0 0 0-7-7ZM8 18a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z" />
    </Icon>
  )
);
export default LightBulbIcon;
